export default "__VITE_ASSET__80a8e16d__"